import { Alert, Box, Link as MuiLink } from "@mui/material";
import Grid from '@mui/material/Grid2';
import React from "react";
import TitleDescription from "../components/TitleDescription";
import { ReactComponent as FinfactorProductsGrid } from "../assets/finfactor-products-grid.svg"
import { ReactComponent as HowFinfactorWorks } from "../assets/how-finfactor-works.svg"
import Title from "../components/Title";
import { useNavigate, useLocation } from "react-router-dom";
import { clearStoredVariant, stripVariantFromHref, useVariant } from "../utils/Variant";
import { VARIANT_LABELS } from "../models/Page";

const HomePage: React.FC = React.memo(() => {
    const variant = useVariant();
    const navigate = useNavigate();
    const location = useLocation();

    const exitVariant = () => {
        clearStoredVariant();
        navigate(stripVariantFromHref(`${location.pathname}${location.search}${location.hash}`), { replace: true });
    };

    return (
        <Box sx={{
            paddingX: 6
        }}>
            {variant && (
                <Alert
                    severity="info"
                    sx={{ mb: 3 }}
                    action={
                        <MuiLink
                            component="button"
                            underline="always"
                            onClick={exitVariant}
                            sx={{ cursor: "pointer", fontSize: 14 }}
                        >
                            View full documentation
                        </MuiLink>
                    }
                >
                    You are viewing the <strong>{VARIANT_LABELS[variant]}</strong> documentation. Some sections are hidden from the sidebar.
                </Alert>
            )}
            <Grid container justifyContent="center" alignItems="center">
                <Grid size={6}>
                    <TitleDescription
                        title="Finfactor’s Developer Documentation"
                        description="A suite of APIs designed to power innovative financial solutions. Our APIs enable seamless integration for key functions such as wealth management, lending and collections, fraud detection, and more. With a focus on simplicity and speed, we offer developer-friendly tools that help you build, scale, and launch financial applications with confidence."
                    />
                </Grid>
                <Grid size={6}>
                    <FinfactorProductsGrid />
                </Grid>
            </Grid>
            <>
                <Title title="How Finfactor works?" paddingBottom={4} />
                <HowFinfactorWorks />
            </>
        </Box>
    );
});

export default HomePage;
